import React from 'react'

const ConfirmEmail = () => {
  return (
    <div>ConfirmEmail</div>
  )
}

export default ConfirmEmail